import * as React from "react";
const SvgIcon40 = props => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 11 7" {...props}><path d="M4.714 1a1 1 0 0 1 1.572 0l3.443 4.382A1 1 0 0 1 8.943 7H2.057a1 1 0 0 1-.786-1.618Z" transform="rotate(180 5.5 3.5)" style={{
    fill: "#a2a2a2"
  }} /></svg>;
export default SvgIcon40;